import React from 'react';
import { Lock } from 'lucide-react';
import { Section, TextField } from './FormFields';

const AccountTab = ({ 
  profileForm, 
  setProfileForm, 
  handleProfileUpdate, 
  savingProfile,
  setShowPasswordModal 
}) => {
  return (
    <div className="space-y-6">
      <Section title="Profile Information" description="Update your account details.">
        <form onSubmit={handleProfileUpdate} className="space-y-4 max-w-md">
          <TextField 
            label="Name" 
            value={profileForm.name} 
            onChange={(v) => setProfileForm({ ...profileForm, name: v })} 
          />
          <TextField 
            label="Email" 
            value={profileForm.email} 
            onChange={(v) => setProfileForm({ ...profileForm, email: v })} 
            type="email" 
          />
          <button 
            type="submit" 
            disabled={savingProfile} 
            className="bg-slate-900 text-white px-6 py-3 rounded-lg font-medium hover:bg-slate-800 disabled:opacity-50"
          >
            {savingProfile ? 'Saving...' : 'Save Changes'}
          </button>
        </form>
      </Section>

      <Section title="Password" description="Change your account password.">
        <button 
          onClick={() => setShowPasswordModal(true)} 
          className="flex items-center gap-2 bg-slate-100 text-slate-700 px-6 py-3 rounded-lg font-medium hover:bg-slate-200"
        >
          <Lock className="w-5 h-5" /> Change Password
        </button>
      </Section>
    </div>
  );
};

export default AccountTab;
